"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DiscardCardStrategy = /*#__PURE__*/function () {
  function DiscardCardStrategy(_ref) {
    var gambler = _ref.gambler;

    _classCallCheck(this, DiscardCardStrategy);

    _defineProperty(this, "strategy", null);

    _defineProperty(this, "gambler", null);

    this.gambler = gambler;
    this.strategy = gambler.isAttacker ? DiscardCardStrategy.Attacker : DiscardCardStrategy.Defender;
  }

  _createClass(DiscardCardStrategy, [{
    key: "discard",
    value: function discard(card, openedCards) {
      var res = this.strategy({
        card: card,
        openedCards: openedCards
      });

      if (res) {
        return this.gambler.removeFromHand(card);
      }

      return false;
    }
  }], [{
    key: "Defender",
    value: function Defender(_ref2) {
      var card = _ref2.card,
          openedCards = _ref2.openedCards;

      if (openedCards.length === 0) {
        return false;
      }

      var lastCard = openedCards[openedCards.length - 1];
      return card.isTrump && !lastCard.isTrump || lastCard.suit === card.suit && lastCard.rank < card.rank;
    }
  }, {
    key: "Attacker",
    value: function Attacker(_ref3) {
      var card = _ref3.card,
          openedCards = _ref3.openedCards;

      if (openedCards.length > 0 && openedCards.some(function (i) {
        return i.rank === card.rank;
      }) === false) {
        return false;
      }

      return true;
    }
  }]);

  return DiscardCardStrategy;
}();

exports["default"] = DiscardCardStrategy;